<template>
  <div
    style="width: 100%; display: flex; align-items: center; justify-content: center;"
  >
    <img src="@/assets/img/logo_blue.svg" alt="logo_picture" />
  </div>
</template>
